export const isPropProvider = (value) => {
    return typeof value === 'function';
};
//# sourceMappingURL=prop-provider.js.map